// 📤 New Version Route
import { createFileRoute } from '@tanstack/react-router';

import { NewVersionPage } from '@/features/versions/pages';

export const Route = createFileRoute('/_authenticated/_withWorkspace/versions/new')({
  component: NewVersionPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      tableId: (search.tableId as string) || undefined,
    };
  },
});
